export default __webpack_public_path__ + "static/media/img-history-2.6d517833.png";